import { atom } from 'recoil';

export const INIT_VALUE_PROGRESS_BAR: number = 0.125;

export const ProgressBarState = atom<number>({
  key: 'progressBarState',
  default: INIT_VALUE_PROGRESS_BAR,
});
